export const isInSDK = () => /\bHub[sS]pot ?Mobile ?SDK\b/.test(window.navigator.userAgent);